module.exports = __webpack_public_path__ + "img/2-en.6329aa40.png";